export default "__VITE_ASSET__db7MCoYv__"